import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
const Container = styled.div `
  background: ${({ theme }) => theme.palette.grey.A800};
  border-radius: 6px;
  padding: 16px;
  color: white;
  font-size: 14px;
`;
const TitleRow = styled.div `
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  grid-gap: 10px;
`;
const ImpactClaimDefinition = ({ impactClaim, title, }) => {
    const { t } = useTranslation();
    return (React.createElement(Container, null,
        React.createElement(TitleRow, null,
            React.createElement("span", null, title ? title : t('impact-claims.impact-definition'))),
        React.createElement("div", null, impactClaim === null || impactClaim === void 0 ? void 0 : impactClaim.impactCatalogItem.definition)));
};
export default ImpactClaimDefinition;
